/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { ErrorDto } from './ErrorDto';
import type { Issuance } from './Issuance';

export type TransactionDashboardDto = {
    id: number;
    transactionId?: string;
    snapId: number;
    collectorId: string;
    sponsorCode: string;
    totalMiles: number;
    type: TransactionDashboardDto.type;
    status?: TransactionDashboardDto.status;
    statusCode?: number;
    createdAt: string;
    canUpdate: boolean;
    isEligibleForParticipationOffer?: boolean;
    errors?: Array<ErrorDto>;
    issuances?: Array<Issuance>;
};

export namespace TransactionDashboardDto {

    export enum type {
        POST = 'POST',
        ISSUE = 'ISSUE',
    }

    export enum status {
        SUCCESS = 'SUCCESS',
        PENDING = 'PENDING',
        ERROR = 'ERROR',
        BACKED_OUT = 'BACKED_OUT',
    }


}

